import { Link } from "react-router-dom";
import { ArrowRight, Zap } from "lucide-react";
import Logo from "../Logo";
import { track } from "../../lib/api";

export default function FinalCta() {
  return (
    <section className="py-28 lg:py-40 border-t border-white/5 relative overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 bg-flame/5" />
      <div className="container-x relative text-center">
        <h2 className="font-heading text-4xl sm:text-6xl lg:text-7xl font-black tracking-tighter text-white">
          WHAT DO YOU WANT<br />TO <span className="text-flame">BUILD?</span>
        </h2>
        <p className="mt-8 text-slate-400 max-w-xl mx-auto leading-relaxed">
          Tell us what you need. We'll analyse the requirement, estimate the development effort and show you how
          quickly we can turn it into working software.
        </p>
        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/get-estimate"
            data-testid="final-cta-estimate-btn"
            onClick={() => track("estimate_click", { location: "final_cta" })}
            className="inline-flex items-center gap-2 rounded-full bg-flame hover:bg-flame-hover text-white font-heading font-bold tracking-wide px-9 py-4 transition-colors shadow-[0_0_36px_rgba(249,115,22,0.45)]"
          >
            GET MY ESTIMATE <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/book-rush-hour"
            data-testid="final-cta-rush-btn"
            onClick={() => track("rush_hour_click", { location: "final_cta" })}
            className="inline-flex items-center gap-2 rounded-full border border-white/25 hover:border-flame hover:text-flame text-white font-heading font-bold tracking-wide px-9 py-4 transition-colors"
          >
            <Zap className="w-4 h-4" /> BOOK RUSH HOUR
          </Link>
        </div>
        <div className="mt-20 flex flex-col items-center gap-3">
          <Logo />
          <p className="font-mono text-[11px] tracking-[0.4em] text-slate-500">BUILD SOFTWARE. LIVE.</p>
        </div>
      </div>
    </section>
  );
}
